import {Component, EventEmitter, Input, OnChanges, Output, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CheckboxItem} from '../../classes/CheckboxItem';

/**
 * This component handles displaying a checkbox and changing its value.
 */
@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.less'],
  imports: [CommonModule, FormsModule]
})
export class CheckboxGroupComponent implements OnChanges {

  /** A list of data, used for checkboxes. */
  @Input() options = Array<CheckboxItem>();
  /** A list of checkbox values, who were checked. */
  @Input() selectedValues: string[];
  /** `True`, if checkboxes should be displayed in more than one column. */
  readonly hasSeveralColumns = input<boolean>(undefined);
  /** An event to return selected checkbox values to a parent component. */
  @Output() checkboxToggled = new EventEmitter<any[]>();

  /**
   * Finds checked checkboxes and returns their values to a parent component.
   */
  onInnerToggle(): void {
    const checkedOptions = this.options.filter(option => option.checked);
    this.selectedValues = checkedOptions.map(checkedOption => checkedOption.value);
    this.checkboxToggled.emit(checkedOptions.map(checkedOption => checkedOption.value));
  }

  /**
   * Updates, which checkbox values were checked.
   */
  ngOnChanges(): void {
    this.selectedValues.forEach(value => {
      const element = this.options.find(option => option.value === value);
      if (element) {
        element.checked = true;
      }
    });
  }
}
